import { gql } from "@apollo/client";

import {
  FRAGMENT_ENTITY,
  FRAGMENT_COMPANY,
  FRAGMENT_CLIENT,
  FRAGMENT_NAMEBOARD,
  FRAGMENT_VISIONECT,
  FRAGMENT_USER,
  FRAGMENT_ENTITY_DESK,
  FRAGMENT_CLIENT_TOKEN,
  FRAGMENT_OUTLOOK_SUBSCRIPTION,
  FRAGMENT_LOG,
  FRAGMENT_ERROR,
  FRAGMENT_NAMEBOARD_SETTINGS,
  FRAGMENT_CLIENT_SENDGRID,
  FRAGMENT_CLIENT_SENDGRID_TEMPLATE,
  FRAGMENT_SCREEN,
  FRAGMENT_EMPLOYEE,
  FRAGMENT_VISITOR,
  FRAGMENT_MEETING,
  FRAGMENT_ACTIVE_DIRECTORY,
  FRAGMENT_ACTIVE_DIRECTORY_SYNC,
  FRAGMENT_DIGITAL_RECEPTION,
  FRAGMENT_CLIENT_PREFERENCES,
  FRAGMENT_SCREEN_SCHEDULE,
  FRAGMENT_MEMBER_GROUP,
  FRAGMENT_PROPERTY,
  FRAGMENT_WAYFINDING_SCREEN,
  FRAGMENT_ENTRANCE_AGREEMENT,
  FRAGMENT_ENTRANCE_AGREEMENT_FILE,
  MINEW_DEVICE_FIELDS,
  FRAGMENT_ENTITY_BASIC,
  FRAGMENT_MANUAL_REGISTRATION,
  FRAGMENT_MANUAL_REGISTRATION_FIELD,
  FRAGMENT_CLIENT_VISITOR_FIELD,
  FRAGMENT_COURIER_DELIVERY,
  FRAGMENT_MS_TEAMS,
  FRAGMENT_GOOGLE_CHAT,
  FRAGMENT_CHAT_MESSAGE_TEMPLATE,
  FRAGMENT_SYNGUARD,
  FRAGMENT_SYNGUARD_STUDENT,
  FRAGMENT_SYNGUARD_CHECKOUT_NETWORK_ITEM,
  FRAGMENT_SHELLY_CONTROLLER,
  FRAGMENT_TUYA,
  FRAGMENT_TUYA_CONTROLLER,
  FRAGMENT_GOOGLE_WORKSPACE,
  FRAGMENT_GOOGLE_WORKSPACE_SYNC,
  FRAGMENT_SYNGUARD_GENERIC_LABEL,
} from "../fragment";

export const CREATE_COMPANY = gql`
  mutation addCompany($input: AddCompanyInput!) {
    addCompany(input: $input) {
      ...FragmentCompany
    }
  }
  ${FRAGMENT_COMPANY}
`;

export const DELETE_COMPANY = gql`
  mutation deleteCompany($id: ID!) {
    deleteCompany(id: $id) {
      ...FragmentCompany
    }
  }
  ${FRAGMENT_COMPANY}
`;

export const DELETE_COMPANIES = gql`
  mutation deleteCompanies($ids: [ID]!) {
    deleteCompanies(ids: $ids) {
      ...FragmentCompany
    }
  }
  ${FRAGMENT_COMPANY}
`;

export const UPDATE_PROPERTY_COMPANY = gql`
  mutation updateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      ...FragmentCompany
    }
  }
  ${FRAGMENT_COMPANY}
`;

export const UPDATE_CLIENT_PREFERENCES = gql`
  mutation updateClientPreferences($input: UpdateClientPreferencesInput!) {
    updateClientPreferences(input: $input) {
      ...FragmentClientPreferences
    }
  }
  ${FRAGMENT_CLIENT_PREFERENCES}
`;

export const REGENERATE_WEBHOOK_SECRET = gql`
  mutation regenerateWebhookSecret {
    regenerateWebhookSecret {
      secret
      secretCreatedAt
    }
  }
`;

export const TEST_WEBHOOK = gql`
  mutation testWebhook($event: WebhookEventName!) {
    testWebhook(event: $event) {
      delivered
      status
      error
      responseBody
    }
  }
`;

export const TOGGLE_CLIENT_FEATURE = gql`
  mutation toggleClientFeature($input: ToggleClientFeatureInput!) {
    toggleClientFeature(input: $input) {
      ...FragmentClientPreferences
    }
  }
  ${FRAGMENT_CLIENT_PREFERENCES}
`;

export const CREATE_SPACE = gql`
  mutation addSpace($input: AddSpaceInput!) {
    addSpace(input: $input) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const UPDATE_SPACE = gql`
  mutation updateSpace($input: UpdateSpaceInput!) {
    updateSpace(input: $input) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_SPACE = gql`
  mutation deleteSpace($id: ID!) {
    deleteSpace(id: $id) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_FLOOR = gql`
  mutation deleteFloor($id: ID!) {
    deleteFloor(id: $id) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_SECTOR = gql`
  mutation deleteSector($id: ID!) {
    deleteSector(id: $id) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_BUILDING = gql`
  mutation deleteBuilding($id: ID!) {
    deleteBuilding(id: $id) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const UPDATE_CLIENT = gql`
  mutation updateClient($input: UpdateClientInput!) {
    updateClient(input: $input) {
      ...FragmentClient
    }
  }
  ${FRAGMENT_CLIENT}
`;

export const CREATE_CLIENT = gql`
  mutation addClient($input: AddClientInput!) {
    addClient(input: $input) {
      ...FragmentClient
    }
  }
  ${FRAGMENT_CLIENT}
`;

export const DELETE_CLIENT = gql`
  mutation deleteClient($id: ID!) {
    deleteClient(id: $id) {
      ...FragmentClient
    }
  }
  ${FRAGMENT_CLIENT}
`;

export const ADD_CLIENT_TOKEN = gql`
  mutation addClientToken($input: AddClientTokenInput!) {
    addClientToken(input: $input) {
      ...FragmentClientToken
    }
  }
  ${FRAGMENT_CLIENT_TOKEN}
`;

export const UPDATE_CLIENT_TOKEN = gql`
  mutation updateClientToken($input: UpdateClientTokenInput!) {
    updateClientToken(input: $input) {
      ...FragmentClientToken
    }
  }
  ${FRAGMENT_CLIENT_TOKEN}
`;

export const DELETE_CLIENT_TOKEN = gql`
  mutation deleteClientToken($input: DeleteClientTokenInput!) {
    deleteClientToken(input: $input) {
      id
    }
  }
`;

export const UPDATE_CLIENT_SENDGRID = gql`
  mutation updateSendGridClient($input: UpdateSendGridClientInput!) {
    updateSendGridClient(input: $input) {
      ...FragmentClientSendGrid
    }
  }
  ${FRAGMENT_CLIENT_SENDGRID}
`;

export const DELETE_CLIENT_TWILIO = gql`
  mutation deleteTwilioClient($id: ID!) {
    deleteTwilioClient(id: $id) {
      id
    }
  }
`;

export const DELETE_CLIENT_SENDGRID = gql`
  mutation deleteSendGridClient($id: ID!) {
    deleteSendGridClient(id: $id) {
      id
    }
  }
`;

export const START_SENDGRID_CLIENT_CREATION = gql`
  mutation startSendGridClientCreation($input: AddSendGridClientInput!) {
    startSendGridClientCreation(input: $input) {
      id
      kind
      status
      message
      sendgridClient
      startedAt
      finishedAt
      result {
        updated
        created
        removed
      }
    }
  }
`;

export const START_SENDGRID_TEMPLATE_SYNC = gql`
  mutation startSendGridTemplateSync($id: ID!) {
    startSendGridTemplateSync(id: $id) {
      id
      kind
      status
      message
      sendgridClient
      startedAt
      finishedAt
      result {
        updated
        created
        removed
      }
    }
  }
`;

export const SET_CLIENT_SENDGRID_AS_DEFAULT = gql`
  mutation setSendGridClientAsDefault($id: ID!) {
    setSendGridClientAsDefault(id: $id) {
      id
      isDefault
    }
  }
`;

export const CREATE_CLIENT_SENDGRID_TEMPLATE = gql`
  mutation addEmailTemplate($input: AddEmailTemplateInput!) {
    addEmailTemplate(input: $input) {
      ...FragmentClientSendGridTemplate
    }
  }
  ${FRAGMENT_CLIENT_SENDGRID_TEMPLATE}
`;

export const UPDATE_CLIENT_SENDGRID_TEMPLATE = gql`
  mutation updateEmailTemplate($input: UpdateEmailTemplateInput!) {
    updateEmailTemplate(input: $input) {
      ...FragmentClientSendGridTemplate
    }
  }
  ${FRAGMENT_CLIENT_SENDGRID_TEMPLATE}
`;

export const DELETE_CLIENT_SENDGRID_TEMPLATE = gql`
  mutation deleteEmailTemplate($id: ID!) {
    deleteEmailTemplate(id: $id) {
      id
    }
  }
`;

export const CREATE_MESSAGE_TEMPLATE = gql`
  mutation createMessageTemplate($input: CreateMessageTemplateInput!) {
    createMessageTemplate(input: $input) {
      id
    }
  }
`;

export const UPDATE_MESSAGE_TEMPLATE = gql`
  mutation updateMessageTemplate($input: UpdateMessageTemplateInput!) {
    updateMessageTemplate(input: $input) {
      id
    }
  }
`;

export const DELETE_MESSAGE_TEMPLATE = gql`
  mutation deleteMessageTemplate($id: ID!) {
    deleteMessageTemplate(id: $id) {
      id
      template
    }
  }
`;

export const CREATE_NAMEBOARD = gql`
  mutation addNameboard($input: AddNameboardInput!) {
    addNameboard(input: $input) {
      ...FragmentNameboard
    }
  }
  ${FRAGMENT_NAMEBOARD}
`;

export const UPDATE_NAMEBOARD = gql`
  mutation updateNameboard($input: UpdateNameboardInput!) {
    updateNameboard(input: $input) {
      ...FragmentNameboard
    }
  }
  ${FRAGMENT_NAMEBOARD}
`;

export const DELETE_SCREEN = gql`
  mutation deleteScreen($id: ID!) {
    deleteScreen(id: $id) {
      ...FragmentScreen
    }
  }
  ${FRAGMENT_SCREEN}
`;

export const DELETE_DIGITAL_RECEPTION = gql`
  mutation deleteDigitalReception($id: ID!) {
    deleteDigitalReception(id: $id) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const UPDATE_NAMEBOARD_SETTINGS = gql`
  mutation updateNameboard($input: UpdateNameboardInput!) {
    updateNameboard(input: $input) {
      id
      metadata
      settings {
        ...FragmentNameboardSettings
      }
    }
  }
  ${FRAGMENT_NAMEBOARD_SETTINGS}
`;

export const CREATE_DIGITAL_RECEPTION = gql`
  mutation createDigitalReception($input: CreateDigitalReceptionInput!) {
    createDigitalReception(input: $input) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const UPDATE_DIGITAL_RECEPTION = gql`
  mutation updateDigitalReception($input: UpdateDigitalReceptionInput!) {
    updateDigitalReception(input: $input) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const MUTATION_GENERATE_DIGITAL_RECEPTION_CODE = gql`
  mutation generateDigitalReceptionCode($id: ID!) {
    generateDigitalReceptionCode(id: $id) {
      id
      code
    }
  }
`;

export const UPDATE_DIGITAL_RECEPTION_THEME = gql`
  mutation updateDigitalReceptionTheme(
    $input: UpdateDigitalReceptionThemeInput!
  ) {
    updateDigitalReceptionTheme(input: $input) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const UPDATE_DIGITAL_RECEPTION_SETTINGS = gql`
  mutation updateDigitalReceptionSettings(
    $input: UpdateDigitalReceptionSettingsInput!
  ) {
    updateDigitalReceptionSettings(input: $input) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const CREATE_ENTITY_PROPERTIES = gql`
  mutation addProperties($input: AddPropertiesInput!) {
    addProperties(input: $input) {
      id
      properties {
        id
        type
        ... on Company {
          title
        }
      }
    }
  }
`;

export const ADD_ENTITY_PROPERTY = gql`
  mutation addProperty($input: AddPropertyInput!) {
    addProperty(input: $input) {
      id
      properties {
        id
        type
        ... on Company {
          title
        }
      }
    }
  }
`;

export const CREATE_NAMEBOARD_ITEM = gql`
  mutation addNameboardItem($input: AddNameboardItemInput!) {
    addNameboardItem(input: $input) {
      id
      entity {
        ...FragmentEntity
      }
      nameboard {
        id
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const UPDATE_NAMEBOARD_ITEM = gql`
  mutation updateNameboardItem($input: UpdateNameboardItemInput!) {
    updateNameboardItem(input: $input) {
      id
      entity {
        ...FragmentEntity
      }
      nameboard {
        id
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_NAMEBOARD_ITEM = gql`
  mutation deleteNameboardItem($id: ID!) {
    deleteNameboardItem(id: $id) {
      nameboard {
        id
      }
    }
  }
`;

export const DELETE_ENTITIES = gql`
  mutation deleteEntities($ids: [ID]!) {
    deleteEntities(ids: $ids) {
      ...FragmentEntity
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const CREATE_NAMEBOARD_PATH = gql`
  mutation addNameboardPath($input: AddNameboardPathInput!) {
    addNameboardPath(input: $input) {
      id
      entity {
        ...FragmentEntity
      }
      nameboard {
        id
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const UPDATE_NAMEBOARD_PATH = gql`
  mutation updateNameboardPath($input: UpdateNameboardPathInput!) {
    updateNameboardPath(input: $input) {
      id
      entity {
        ...FragmentEntity
      }
      nameboard {
        id
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_NAMEBOARD_PATH = gql`
  mutation deleteNameboardPath($id: ID!) {
    deleteNameboardPath(id: $id) {
      nameboard {
        id
      }
    }
  }
`;

export const CREATE_VISIONECT = gql`
  mutation createVisionect($input: CreateVisionect!) {
    createVisionect(input: $input) {
      ...FragmentVisionect
    }
  }
  ${FRAGMENT_VISIONECT}
`;

export const UPDATE_VISIONECT = gql`
  mutation updateVisionect($input: UpdateVisionect!) {
    updateVisionect(input: $input) {
      ...FragmentVisionect
    }
  }
  ${FRAGMENT_VISIONECT}
`;

export const CREATE_MINEW = gql`
  mutation createMinew($input: CreateMinew!) {
    createMinew(input: $input) {
      id
      title
      device {
        mac
      }
    }
  }
`;

export const UPDATE_MINEW = gql`
  mutation updateMinew($input: UpdateMinew!) {
    updateMinew(input: $input) {
      id
      title
      device {
        mac
      }
    }
  }
`;
export const DELETE_MINEW = gql`
  mutation deleteMinew($id: ID!) {
    deleteMinew(id: $id) {
      id
    }
  }
`;

export const RESTART_MINEW = gql`
  mutation restartMinew($id: ID!) {
    restartMinew(id: $id) {
      id
    }
  }
`;

export const RESTART_VISIONECT = gql`
  mutation restartVisionect($id: ID!) {
    restartVisionect(id: $id) {
      id
    }
  }
`;

export const DELETE_VISIONECT = gql`
  mutation deleteVisionect($id: ID!) {
    deleteVisionect(id: $id) {
      ...FragmentVisionect
    }
  }
  ${FRAGMENT_VISIONECT}
`;

export const CREATE_VISIONECT_ITEM = gql`
  mutation createVisionectItem($input: CreateVisionectItemInput!) {
    createVisionectItem(input: $input) {
      id
      direction
      entity {
        ...FragmentEntity
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const UPDATE_VISIONECT_ITEM = gql`
  mutation updateVisionectItem($input: UpdateVisionectItemInput!) {
    updateVisionectItem(input: $input) {
      id
      direction
      entity {
        ...FragmentEntity
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const DELETE_VISIONECT_ITEM = gql`
  mutation deleteVisionectItem($id: ID!) {
    deleteVisionectItem(id: $id) {
      direction
      entity {
        ...FragmentEntity
      }
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const CREATE_MINEW_ITEM = gql`
  mutation createMinewItem($input: CreateMinewItemInput!) {
    createMinewItem(input: $input) {
      id
      entity {
        ...FragmentEntityBasic
      }
    }
  }
  ${FRAGMENT_ENTITY_BASIC}
`;

export const UPDATE_MINEW_ITEM = gql`
  mutation updateMinewItem($input: UpdateMinewItemInput!) {
    updateMinewItem(input: $input) {
      id
      entity {
        ...FragmentEntityBasic
      }
    }
  }
  ${FRAGMENT_ENTITY_BASIC}
`;

export const DELETE_MINEW_ITEM = gql`
  mutation deleteMinewItem($id: ID!) {
    deleteMinewItem(id: $id) {
      entity {
        ...FragmentEntityBasic
      }
    }
  }
  ${FRAGMENT_ENTITY_BASIC}
`;

export const MUTATION_CREATE_MINEW_CREDENTIALS = gql`
  mutation createMinewCredentials($input: CreateMinewCredentialsInput!) {
    createMinewCredentials(input: $input) {
      id
      title
      host
      username
      password
      accessProfile
    }
  }
`;

export const MUTATION_UPDATE_MINEW_CREDENTIALS = gql`
  mutation updateMinewCredentials($input: UpdateMinewCredentialsInput!) {
    updateMinewCredentials(input: $input) {
      id
      title
      host
      username
      password
      accessProfile
    }
  }
`;

export const CREATE_VISIONECT_DEVICE = gql`
  mutation addVisionectDevice($input: AddVisionectDeviceInput!) {
    addVisionectDevice(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_VISIONECT_DEVICE = gql`
  mutation updateVisionectDevice($input: UpdateVisionectDeviceInput!) {
    updateVisionectDevice(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_VISIONECT_DEVICE = gql`
  mutation deleteVisionectDevice($id: ID!) {
    deleteVisionectDevice(id: $id) {
      id
      name
    }
  }
  ${FRAGMENT_ENTITY}
`;

export const CREATE_MINEW_DEVICE = gql`
  mutation addMinewDevice($input: AddMinewDeviceInput!) {
    addMinewDevice(input: $input) {
      ...MinewDeviceFields
    }
  }
  ${MINEW_DEVICE_FIELDS}
`;

export const UPDATE_MINEW_DEVICE = gql`
  mutation updateMinewDevice($input: UpdateMinewDeviceInput!) {
    updateMinewDevice(input: $input) {
      ...MinewDeviceFields
    }
  }
  ${MINEW_DEVICE_FIELDS}
`;

export const DELETE_MINEW_DEVICE = gql`
  mutation deleteMinewDevice($id: ID!) {
    deleteMinewDevice(id: $id) {
      ...MinewDeviceFields
    }
  }
  ${MINEW_DEVICE_FIELDS}
`;

export const CREATE_USER = gql`
  mutation addUser($input: AddUserInput!) {
    addUser(input: $input) {
      ...FragmentUser
    }
  }
  ${FRAGMENT_USER}
`;

export const UPDATE_USER = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      ...FragmentUser
    }
  }
  ${FRAGMENT_USER}
`;

export const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      ...FragmentUser
    }
  }
  ${FRAGMENT_USER}
`;

export const ADD_ENTITY_DESK = gql`
  mutation addEntityDesk($input: AddEntityDeskInput!) {
    addEntityDesk(input: $input) {
      ...FragmentEntityDesk
    }
  }
  ${FRAGMENT_ENTITY_DESK}
`;

export const UPDATE_ENTITY_DESK = gql`
  mutation updateEntityDesk($input: UpdateEntityDeskInput!) {
    updateEntityDesk(input: $input) {
      ...FragmentEntityDesk
    }
  }
  ${FRAGMENT_ENTITY_DESK}
`;

export const DELETE_ENTITY_DESK = gql`
  mutation deleteEntityDesk($id: ID!) {
    deleteEntityDesk(id: $id) {
      ...FragmentEntityDesk
    }
  }
  ${FRAGMENT_ENTITY_DESK}
`;

export const UPDATE_OUTLOOK_SUBSCRIPTION = gql`
  mutation updateOutlookSubscription($input: UpdateOutlookSubscriptionInput!) {
    updateOutlookSubscription(input: $input) {
      ...FragmentOutlookSubscription
    }
  }
  ${FRAGMENT_OUTLOOK_SUBSCRIPTION}
`;

export const DELETE_OUTLOOK_SUBSCRIPTION = gql`
  mutation deleteOutlookSubscription($id: ID!) {
    deleteOutlookSubscription(id: $id) {
      ...FragmentOutlookSubscription
    }
  }
  ${FRAGMENT_OUTLOOK_SUBSCRIPTION}
`;

export const CONNECT_OUTLOOK_APP_ONLY = gql`
  mutation connectOutlookAppOnly($input: ConnectOutlookAppOnlyInput!) {
    connectOutlookAppOnly(input: $input) {
      ...FragmentOutlookSubscription
    }
  }
  ${FRAGMENT_OUTLOOK_SUBSCRIPTION}
`;

export const SWITCH_OUTLOOK_SUBSCRIPTION_TO_APP_ONLY = gql`
  mutation switchOutlookSubscriptionToAppOnly(
    $input: SwitchOutlookSubscriptionToAppOnlyInput!
  ) {
    switchOutlookSubscriptionToAppOnly(input: $input) {
      ...FragmentOutlookSubscription
    }
  }
  ${FRAGMENT_OUTLOOK_SUBSCRIPTION}
`;

export const MUTATION_DELETE_ACTIVE_DIRECTORY_INTEGRATION = gql`
  mutation deleteActiveDirectory($id: ID!) {
    deleteActiveDirectory(id: $id) {
      ...FragmentActiveDirectory
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY}
`;

export const MUTATION_UPDATE_ACTIVE_DIRECTORY = gql`
  mutation updateActiveDirectory($input: UpdateActiveDirectoryInput!) {
    updateActiveDirectory(input: $input) {
      ...FragmentActiveDirectory
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY}
`;

export const CONNECT_ACTIVE_DIRECTORY_APP_ONLY = gql`
  mutation connectActiveDirectoryAppOnly(
    $input: ConnectActiveDirectoryAppOnlyInput!
  ) {
    connectActiveDirectoryAppOnly(input: $input) {
      ...FragmentActiveDirectory
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY}
`;

export const SWITCH_ACTIVE_DIRECTORY_TO_APP_ONLY = gql`
  mutation switchActiveDirectoryToAppOnly(
    $input: SwitchActiveDirectoryToAppOnlyInput!
  ) {
    switchActiveDirectoryToAppOnly(input: $input) {
      ...FragmentActiveDirectory
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY}
`;

export const MUTATION_CREATE_ACTIVE_DIRECTORY_SYNC = gql`
  mutation createActiveDirectorySync($input: CreateActiveDirectorySyncInput!) {
    createActiveDirectorySync(input: $input) {
      ...FragmentActiveDirectorySync
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY_SYNC}
`;

export const MUTATION_UPDATE_ACTIVE_DIRECTORY_SYNC = gql`
  mutation updateActiveDirectorySync($input: UpdateActiveDirectorySyncInput!) {
    updateActiveDirectorySync(input: $input) {
      ...FragmentActiveDirectorySync
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY_SYNC}
`;

export const MUTATION_DELETE_ACTIVE_DIRECTORY_SYNC = gql`
  mutation deleteActiveDirectorySync($input: DeleteActiveDirectorySyncInput!) {
    deleteActiveDirectorySync(input: $input) {
      ...FragmentActiveDirectorySync
    }
  }
  ${FRAGMENT_ACTIVE_DIRECTORY_SYNC}
`;

export const UPDATE_TWILIO_CLIENT = gql`
  mutation updateTwilioClient($input: UpdateTwilioClientInput!) {
    updateTwilioClient(input: $input) {
      id
    }
  }
`;

export const CREATE_TWILIO_CLIENT = gql`
  mutation addTwilioClient($input: AddTwilioClientInput!) {
    addTwilioClient(input: $input) {
      id
    }
  }
`;

export const CREATE_POSTBOX = gql`
  mutation addPostbox($input: AddPostboxInput!) {
    addPostbox(input: $input) {
      ...FragmentScreen
    }
  }
  ${FRAGMENT_SCREEN}
`;

export const UPDATE_POSTBOX = gql`
  mutation updatePostbox($input: UpdatePostboxInput!) {
    updatePostbox(input: $input) {
      ...FragmentScreen
    }
  }
  ${FRAGMENT_SCREEN}
`;

export const CREATE_FLOOR_INFO = gql`
  mutation addFloorInfo($input: AddFloorInfoInput!) {
    addFloorInfo(input: $input) {
      ...FragmentScreen
    }
  }
  ${FRAGMENT_SCREEN}
`;

export const UPDATE_FLOOR_INFO = gql`
  mutation updateFloorInfo($input: UpdateFloorInfoInput!) {
    updateFloorInfo(input: $input) {
      ...FragmentScreen
    }
  }
  ${FRAGMENT_SCREEN}
`;

export const MUTATION_CREATE_EMPLOYEE = gql`
  mutation createEmployee($input: CreateEmployeeInput!) {
    createEmployee(input: $input) {
      ...FragmentEmployee
    }
  }
  ${FRAGMENT_EMPLOYEE}
`;

export const MUTATION_UPDATE_EMPLOYEE = gql`
  mutation updateEmployee($input: UpdateEmployeeInput!) {
    updateEmployee(input: $input) {
      ...FragmentEmployee
    }
  }
  ${FRAGMENT_EMPLOYEE}
`;

export const MUTATION_DELETE_EMPLOYEE = gql`
  mutation deleteEmployee($id: ID!) {
    deleteEmployee(id: $id) {
      id
      fullName
    }
  }
`;

export const MUTATION_DELETE_EMPLOYEES = gql`
  mutation deleteEmployees($ids: [ID]!) {
    deleteEmployees(ids: $ids) {
      id
    }
  }
`;

export const MUTATION_DELETE_COMPANY_EMPLOYEES = gql`
  mutation deleteCompanyEmployees($input: DeleteCompanyEmployeesInput!) {
    deleteCompanyEmployees(input: $input) {
      scheduled
      employeeCount
    }
  }
`;

export const MUTATION_CREATE_VISITOR = gql`
  mutation createVisitor($input: CreateVisitorInput!) {
    createVisitor(input: $input) {
      ...FragmentVisitor
    }
  }
  ${FRAGMENT_VISITOR}
`;
export const MUTATION_UPDATE_VISITOR = gql`
  mutation updateVisitor($input: UpdateVisitorInput!) {
    updateVisitor(input: $input) {
      ...FragmentVisitor
    }
  }
  ${FRAGMENT_VISITOR}
`;

export const MUTATION_DELETE_VISITOR = gql`
  mutation deleteVisitor($id: ID!) {
    deleteVisitor(id: $id) {
      id
      fullName
    }
  }
`;

export const MUTATION_DELETE_VISITORS = gql`
  mutation deleteVisitors($ids: [ID]!) {
    deleteVisitors(ids: $ids) {
      id
    }
  }
`;

export const MUTATION_ERASE_MEMBER_DATA = gql`
  mutation eraseMemberData($id: ID, $email: String) {
    eraseMemberData(id: $id, email: $email) {
      memberType
      eventsAnonymized
      hostSnapshotsScrubbed
      masterDeleted
    }
  }
`;

export const MUTATION_CREATE_MEETING = gql`
  mutation createMeeting($input: CreateMeetingInput!) {
    createMeeting(input: $input) {
      ...FragmentMeeting
    }
  }
  ${FRAGMENT_MEETING}
`;

export const MUTATION_UPDATE_MEETING = gql`
  mutation updateMeeting($input: UpdateMeetingInput!) {
    updateMeeting(input: $input) {
      ...FragmentMeeting
    }
  }
  ${FRAGMENT_MEETING}
`;

export const MUTATION_DELETE_MEETING = gql`
  mutation deleteMeeting($id: ID!) {
    deleteMeeting(id: $id) {
      id
    }
  }
`;

export const MUTATION_DELETE_MEETINGS = gql`
  mutation deleteMeetings($ids: [ID]!) {
    deleteMeetings(ids: $ids) {
      id
    }
  }
`;

export const MUTATION_RESEND_MEMBER_ACCESS = gql`
  mutation resendMemberAccess($id: ID!) {
    resendMemberAccess(id: $id) {
      id
    }
  }
`;

export const MUTATION_SEND_EMPLOYEE_PIN_CHANGE_EMAIL = gql`
  mutation sendEmployeePinChangeEmail($id: ID!) {
    sendEmployeePinChangeEmail(id: $id)
  }
`;

export const MUTATION_CREATE_MEMBER_ACCESS = gql`
  mutation createMemberAccess($input: CreateMemberAccessInput!) {
    createMemberAccess(input: $input) {
      id
    }
  }
`;

export const MUTATION_FORGOT_PASSWORD = gql`
  mutation forgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input)
  }
`;

export const MUTATION_RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

export const MUTATION_CHANGE_PASSWORD = gql`
  mutation changePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;

export const MUTATION_CONFIRM_EMAIL = gql`
  mutation confirmEmail($input: VerifyEmailInput!) {
    confirmEmail(input: $input) {
      alreadyConfirmed
      token
      resetPasswordCode
    }
  }
`;

export const MUTATION_CREATE_SCREEN_SCHEDULE = gql`
  mutation createScreenSchedule($input: CreateScreenScheduleInput!) {
    createScreenSchedule(input: $input) {
      ...FragmentScreenSchedule
    }
  }
  ${FRAGMENT_SCREEN_SCHEDULE}
`;

export const MUTATION_UPDATE_SCREEN_SCHEDULE = gql`
  mutation updateScreenSchedule($input: UpdateScreenScheduleInput!) {
    updateScreenSchedule(input: $input) {
      ...FragmentScreenSchedule
    }
  }
  ${FRAGMENT_SCREEN_SCHEDULE}
`;

export const MUTATION_DELETE_SCREEN_SCHEDULE = gql`
  mutation deleteScreenSchedule($id: ID!) {
    deleteScreenSchedule(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_MEMBER_GROUP = gql`
  mutation createMemberGroup($input: CreateMemberGroupInput!) {
    createMemberGroup(input: $input) {
      ...FragmentMemberGroup
    }
  }
  ${FRAGMENT_MEMBER_GROUP}
`;

export const MUTATION_UPDATE_MEMBER_GROUP = gql`
  mutation updateMemberGroup($input: UpdateMemberGroupInput!) {
    updateMemberGroup(input: $input) {
      message
    }
  }
`;

export const MUTATION_DELETE_MEMBER_GROUP = gql`
  mutation deleteMemberGroup($id: ID!) {
    deleteMemberGroup(id: $id) {
      message
    }
  }
`;

export const CREATE_DECEASED = gql`
  mutation createDeceased($input: DeceasedAdd!) {
    createDeceased(input: $input) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const UPDATE_DECEASED = gql`
  mutation updateDeceased($input: DeceasedUpdate!) {
    updateDeceased(input: $input) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const DELETE_DECEASED = gql`
  mutation deleteDeceased($id: ID!) {
    deleteDeceased(id: $id) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const CREATE_OPENING_HOURS = gql`
  mutation createOpeningHours($input: OpeningHoursAdd!) {
    createOpeningHours(input: $input) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const UPDATE_OPENING_HOURS = gql`
  mutation updateOpeningHours($input: OpeningHoursUpdate!) {
    updateOpeningHours(input: $input) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const DELETE_OPENING_HOURS = gql`
  mutation deleteOpeningHours($id: ID!) {
    deleteOpeningHours(id: $id) {
      ...FragmentProperty
    }
  }
  ${FRAGMENT_PROPERTY}
`;

export const UPDATE_WAYFINDING_SCREEN = gql`
  mutation updateWayfindingScreen($input: WayfindingScreenUpdate!) {
    updateWayfindingScreen(input: $input) {
      ...FragmentWayfindingScreen
    }
  }
  ${FRAGMENT_WAYFINDING_SCREEN}
`;

export const MUTATION_RESEND_VERIFICATION_EMAIL = gql`
  mutation resendVerificationEmail($input: ResendVerificationEmailInput!) {
    resendVerificationEmail(input: $input)
  }
`;

export const MUTATION_EMAIL_CHANGE_REQUEST = gql`
  mutation emailChangeRequest($input: EmailChangeRequestInput!) {
    emailChangeRequest(input: $input)
  }
`;

export const MUTATION_RESEND_VERIFICATION_EMAIL_CHANGE = gql`
  mutation resendVerificationEmailChange(
    $input: ResendVerificationEmailInput!
  ) {
    resendVerificationEmailChange(input: $input)
  }
`;

export const MUTATION_GENERATE_2FA_QR_CODE = gql`
  mutation generate2faQrCode($input: VerifyPasswordInput!) {
    generate2faQrCode(input: $input) {
      qrCode
    }
  }
`;

export const MUTATION_ENABLE_2FA_AUTH = gql`
  mutation enable2faAuth($input: User2faInput!) {
    enable2faAuth(input: $input) {
      enabled
    }
  }
`;

export const MUTATION_DISABLE_2FA_AUTH = gql`
  mutation disable2faAuth($input: VerifyPasswordInput!) {
    disable2faAuth(input: $input) {
      enabled
    }
  }
`;

export const MUTATION_USER_LOGIN_2FA = gql`
  mutation login2faCode($input: User2faInput!) {
    login2faCode(input: $input) {
      token
      expiresIn
    }
  }
`;

export const MUTATION_USER_LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export const MUTATION_USER_LOGIN = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      token
      expiresIn
      requires2fa
    }
  }
`;

export const MUTATION_USER_LOGIN_WITH_GOOGLE = gql`
  mutation loginWithGoogle($input: GoogleLoginInput!) {
    loginWithGoogle(input: $input) {
      token
      expiresIn
      requires2fa
    }
  }
`;

export const MUTATION_CREATE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT = gql`
  mutation createEntranceAgreement($input: CreateEntranceAgreementInput!) {
    createEntranceAgreement(input: $input) {
      ...FragmentEntranceAgreement
    }
  }
  ${FRAGMENT_ENTRANCE_AGREEMENT}
`;

export const MUTATION_UPDATE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT = gql`
  mutation updateEntranceAgreement($input: UpdateEntranceAgreementInput!) {
    updateEntranceAgreement(input: $input) {
      ...FragmentEntranceAgreement
    }
  }
  ${FRAGMENT_ENTRANCE_AGREEMENT}
`;

export const MUTATION_DELETE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT = gql`
  mutation deleteEntranceAgreement($id: ID!) {
    deleteEntranceAgreement(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT_FILE = gql`
  mutation createEntranceAgreementFile(
    $input: CreateEntranceAgreementFileInput!
  ) {
    createEntranceAgreementFile(input: $input) {
      ...FragmentEntranceAgreementFile
    }
  }
  ${FRAGMENT_ENTRANCE_AGREEMENT_FILE}
`;

export const MUTATION_UPDATE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT_FILE = gql`
  mutation updateEntranceAgreementFile(
    $input: UpdateEntranceAgreementFileInput!
  ) {
    updateEntranceAgreementFile(input: $input) {
      ...FragmentEntranceAgreementFile
    }
  }
  ${FRAGMENT_ENTRANCE_AGREEMENT_FILE}
`;

export const MUTATION_DELETE_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT_FILE = gql`
  mutation deleteEntranceAgreementFile($id: ID!) {
    deleteEntranceAgreementFile(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_DIGITAL_RECEPTION_MANUAL_REGISTRATION = gql`
  mutation createManualRegistration($input: CreateManualRegistrationInput!) {
    createManualRegistration(input: $input) {
      ...FragmentManualRegistration
    }
  }
  ${FRAGMENT_MANUAL_REGISTRATION}
`;

export const MUTATION_UPDATE_DIGITAL_RECEPTION_MANUAL_REGISTRATION = gql`
  mutation updateManualRegistration($input: UpdateManualRegistrationInput!) {
    updateManualRegistration(input: $input) {
      ...FragmentManualRegistration
    }
  }
  ${FRAGMENT_MANUAL_REGISTRATION}
`;

export const MUTATION_DELETE_DIGITAL_RECEPTION_MANUAL_REGISTRATION = gql`
  mutation deleteManualRegistration($id: ID!) {
    deleteManualRegistration(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_DIGITAL_RECEPTION_MANUAL_REGISTRATION_FIELD = gql`
  mutation createManualRegistrationField(
    $input: CreateManualRegistrationFieldInput!
  ) {
    createManualRegistrationField(input: $input) {
      ...FragmentManualRegistrationField
    }
  }
  ${FRAGMENT_MANUAL_REGISTRATION_FIELD}
`;

export const MUTATION_UPDATE_DIGITAL_RECEPTION_MANUAL_REGISTRATION_FIELD = gql`
  mutation updateManualRegistrationField(
    $input: UpdateManualRegistrationFieldInput!
  ) {
    updateManualRegistrationField(input: $input) {
      ...FragmentManualRegistrationField
    }
  }
  ${FRAGMENT_MANUAL_REGISTRATION_FIELD}
`;

export const MUTATION_DELETE_DIGITAL_RECEPTION_MANUAL_REGISTRATION_FIELD = gql`
  mutation deleteManualRegistrationField($id: ID!) {
    deleteManualRegistrationField(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_CLIENT_VISITOR_FIELD = gql`
  mutation createClientVisitorField($input: CreateClientVisitorFieldInput!) {
    createClientVisitorField(input: $input) {
      ...FragmentClientVisitorField
    }
  }
  ${FRAGMENT_CLIENT_VISITOR_FIELD}
`;

export const MUTATION_UPDATE_CLIENT_VISITOR_FIELD = gql`
  mutation updateClientVisitorField($input: UpdateClientVisitorFieldInput!) {
    updateClientVisitorField(input: $input) {
      ...FragmentClientVisitorField
    }
  }
  ${FRAGMENT_CLIENT_VISITOR_FIELD}
`;

export const MUTATION_REORDER_CLIENT_VISITOR_FIELDS = gql`
  mutation reorderClientVisitorFields(
    $items: [ReorderClientVisitorFieldInput!]!
    $language: String
  ) {
    reorderClientVisitorFields(items: $items, language: $language) {
      ...FragmentClientVisitorField
    }
  }
  ${FRAGMENT_CLIENT_VISITOR_FIELD}
`;

export const MUTATION_REORDER_DIGITAL_RECEPTION_ENTRANCE_AGREEMENT_FILES = gql`
  mutation reorderEntranceAgreementFiles(
    $items: [ReorderEntranceAgreementFileInput!]!
  ) {
    reorderEntranceAgreementFiles(items: $items) {
      ...FragmentEntranceAgreementFile
    }
  }
  ${FRAGMENT_ENTRANCE_AGREEMENT_FILE}
`;

export const MUTATION_DELETE_CLIENT_VISITOR_FIELD = gql`
  mutation deleteClientVisitorField($id: ID!) {
    deleteClientVisitorField(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_COURIER_DELIVERY = gql`
  mutation createCourierDelivery($input: CreateCourierDeliveryInput!) {
    createCourierDelivery(input: $input) {
      ...FragmentCourierDelivery
    }
  }
  ${FRAGMENT_COURIER_DELIVERY}
`;

export const MUTATION_DELETE_COURIER_DELIVERY = gql`
  mutation deleteCourierDelivery($id: ID!) {
    deleteCourierDelivery(id: $id) {
      id
    }
  }
`;

export const MUTATION_RESET_ACTIVE_COURIER_DELIVERY = gql`
  mutation resetActiveCourierDelivery {
    resetActiveCourierDelivery {
      message
    }
  }
`;

export const MUTATION_NEDAP_SYNC_SYNC = gql`
  mutation NedapSync($input: NedapSyncInput!) {
    nedapSync(input: $input) {
      id
    }
  }
`;

export const MUTATION_NEDAP_SYNC_DELETE = gql`
  mutation NedapSync($input: NedapSyncInput!) {
    deleteNedapSync(input: $input)
  }
`;

export const MUTATION_UPDATE_BADGE_TEMPLATE_OPTIONS = gql`
  mutation UpdateBadgeTemplateOptions(
    $input: BrotherPrinterTemplateOptionsInput!
  ) {
    updateBrotherPrinterTemplateOptions(input: $input) {
      client
      enabled
      showCardLabel
      showImage
      showFullName
      showVisitingLabel
      showVisitorCompany
      showEmployeeName
      showCompany
      showCheckinDate
      showLogo
      showAccessCode
      logo
    }
  }
`;

export const MUTATION_SET_CLIENT_TEAMS_MODE = gql`
  mutation setClientTeamsMode($input: SetClientTeamsModeInput!) {
    setClientTeamsMode(input: $input) {
      teams {
        enabled
        mode
      }
    }
  }
`;

export const MUTATION_DELETE_MS_TEAMS_INTEGRATION = gql`
  mutation deleteTeams($id: ID!) {
    deleteTeams(id: $id) {
      ...FragmentTeams
    }
  }
  ${FRAGMENT_MS_TEAMS}
`;

export const MUTATION_DELETE_GOOGLE_CHAT = gql`
  mutation deleteGoogleChat($id: ID!) {
    deleteGoogleChat(id: $id) {
      ...FragmentGoogleChat
    }
  }
  ${FRAGMENT_GOOGLE_CHAT}
`;

export const MUTATION_CHECKOUT_OWNER = gql`
  mutation checkOutOwner($id: ID!) {
    checkOutOwner(id: $id) {
      id
    }
  }
`;

export const MUTATION_SET_GROUPS_FOR_EMPLOYEES = gql`
  mutation setGroupsForEmployees($input: SetGroupsForEmployeesInput!) {
    setGroupsForEmployees(input: $input)
  }
`;

export const MUTATION_SET_GROUPS_FOR_ALL_EMPLOYEES = gql`
  mutation setGroupsForAllEmployees($input: SetGroupsForAllEmployeesInput!) {
    setGroupsForAllEmployees(input: $input)
  }
`;

export const DUPLICATE_DIGITAL_RECEPTION = gql`
  mutation duplicateDigitalReception($id: ID!) {
    duplicateDigitalReception(id: $id) {
      ...FragmentDigitalReception
    }
  }
  ${FRAGMENT_DIGITAL_RECEPTION}
`;

export const MUTATION_CREATE_SYNGUARD = gql`
  mutation createSynguard($input: CreateSynguardInput!) {
    createSynguard(input: $input) {
      ...FragmentSynguard
    }
  }
  ${FRAGMENT_SYNGUARD}
`;

export const MUTATION_UPDATE_SYNGUARD = gql`
  mutation updateSynguard($input: UpdateSynguardInput!) {
    updateSynguard(input: $input) {
      ...FragmentSynguard
    }
  }
  ${FRAGMENT_SYNGUARD}
`;

export const MUTATION_DELETE_SYNGUARD = gql`
  mutation deleteSynguard($id: ID!) {
    deleteSynguard(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_SYNGUARD_CHECKOUT_NETWORK_ITEM = gql`
  mutation createSynguardCheckoutNetworkItem(
    $input: CreateSynguardCheckoutNetworkItemInput!
  ) {
    createSynguardCheckoutNetworkItem(input: $input) {
      ...FragmentSynguardCheckoutNetworkItem
    }
  }
  ${FRAGMENT_SYNGUARD_CHECKOUT_NETWORK_ITEM}
`;

export const MUTATION_DELETE_SYNGUARD_CHECKOUT_NETWORK_ITEM = gql`
  mutation deleteSynguardCheckoutNetworkItem($id: ID!) {
    deleteSynguardCheckoutNetworkItem(id: $id) {
      id
    }
  }
`;

export const MUTATION_START_SYNGUARD_MONITORING = gql`
  mutation startSynguardMonitoring($id: ID!) {
    startSynguardMonitoring(id: $id) {
      id
    }
  }
`;

export const MUTATION_STOP_SYNGUARD_MONITORING = gql`
  mutation stopSynguardMonitoring($id: ID!) {
    stopSynguardMonitoring(id: $id) {
      id
    }
  }
`;

export const MUTATION_RESET_SYNGUARD_STUDENT = gql`
  mutation resetSynguardStudent($id: ID!) {
    resetSynguardStudent(id: $id) {
      ...FragmentSynguardStudent
    }
  }
  ${FRAGMENT_SYNGUARD_STUDENT}
`;

export const MUTATION_RESET_SYNGUARD_STUDENTS = gql`
  mutation resetSynguardStudents($ids: [ID]!) {
    resetSynguardStudents(ids: $ids)
  }
`;

export const MUTATION_BLOCK_SYNGUARD_STUDENT = gql`
  mutation blockSynguardStudent($id: ID!) {
    blockSynguardStudent(id: $id) {
      ...FragmentSynguardStudent
    }
  }
  ${FRAGMENT_SYNGUARD_STUDENT}
`;

export const MUTATION_BLOCK_SYNGUARD_STUDENTS = gql`
  mutation blockSynguardStudents($ids: [ID]!) {
    blockSynguardStudents(ids: $ids)
  }
`;

export const MUTATION_DELETE_SYNGUARD_STUDENT = gql`
  mutation deleteSynguardStudent($id: ID!) {
    deleteSynguardStudent(id: $id)
  }
`;

export const MUTATION_DELETE_SYNGUARD_STUDENTS = gql`
  mutation deleteSynguardStudents($ids: [ID]!) {
    deleteSynguardStudents(ids: $ids)
  }
`;

export const DELETE_SHELLY_CONTROLLER = gql`
  mutation deleteShellyController($id: ID!) {
    deleteShellyController(id: $id) {
      id
    }
  }
`;

export const CREATE_SHELLY_CONTROLLER = gql`
  mutation createShellyController($input: CreateShellyControllerInput!) {
    createShellyController(input: $input) {
      ...FragmentShellyController
    }
  }
  ${FRAGMENT_SHELLY_CONTROLLER}
`;

export const UPDATE_SHELLY_CONTROLLER = gql`
  mutation updateShellyController($input: UpdateShellyControllerInput!) {
    updateShellyController(input: $input) {
      ...FragmentShellyController
    }
  }
  ${FRAGMENT_SHELLY_CONTROLLER}
`;

export const MUTATION_SWITCH_SHELLY_CONTROLLER = gql`
  mutation switchShellyController($input: SwitchShellyControllerInput!) {
    switchShellyController(input: $input)
  }
`;

export const MUTATION_GENERATE_OPEN_DOOR_URL = gql`
  mutation generateOpenDoorUrl($input: GenerateOpenDoorUrlInput!) {
    generateOpenDoorUrl(input: $input)
  }
`;

export const MUTATION_CREATE_TUYA = gql`
  mutation createTuya($input: CreateTuyaInput!) {
    createTuya(input: $input) {
      ...FragmentTuya
    }
  }
  ${FRAGMENT_TUYA}
`;

export const MUTATION_UPDATE_TUYA = gql`
  mutation updateTuya($input: UpdateTuyaInput!) {
    updateTuya(input: $input) {
      ...FragmentTuya
    }
  }
  ${FRAGMENT_TUYA}
`;

export const MUTATION_DELETE_TUYA = gql`
  mutation deleteTuya($id: ID!) {
    deleteTuya(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_TUYA_CONTROLLER = gql`
  mutation createTuyaController($input: CreateTuyaControllerInput!) {
    createTuyaController(input: $input) {
      ...FragmentTuyaController
    }
  }
  ${FRAGMENT_TUYA_CONTROLLER}
`;

export const MUTATION_DELETE_TUYA_CONTROLLER = gql`
  mutation deleteTuyaController($id: ID!) {
    deleteTuyaController(id: $id) {
      id
    }
  }
`;

export const MUTATION_START_TUYA_MONITORING = gql`
  mutation startTuyaMonitoring($id: ID!) {
    startTuyaMonitoring(id: $id) {
      id
    }
  }
`;

export const MUTATION_STOP_TUYA_MONITORING = gql`
  mutation stopTuyaMonitoring($id: ID!) {
    stopTuyaMonitoring(id: $id) {
      id
    }
  }
`;

export const MUTATION_SYNC_TUYA_CONTROLLER_MEMBERS = gql`
  mutation SyncTuyaControllerMembers($controllerId: ID!) {
    syncTuyaControllerMembers(controllerId: $controllerId)
  }
`;

export const MUTATION_DELETE_GOOGLE_WORKSPACE_INTEGRATION = gql`
  mutation deleteGoogleWorkspace($id: ID!) {
    deleteGoogleWorkspace(id: $id) {
      ...FragmentGoogleWorkspace
    }
  }
  ${FRAGMENT_GOOGLE_WORKSPACE}
`;

export const MUTATION_CREATE_GOOGLE_WORKSPACE_SYNC = gql`
  mutation createGoogleWorkspaceSync($input: CreateGoogleWorkspaceSyncInput!) {
    createGoogleWorkspaceSync(input: $input) {
      ...FragmentGoogleWorkspaceSync
    }
  }
  ${FRAGMENT_GOOGLE_WORKSPACE_SYNC}
`;

export const MUTATION_UPDATE_GOOGLE_WORKSPACE_SYNC = gql`
  mutation updateGoogleWorkspaceSync($input: UpdateGoogleWorkspaceSyncInput!) {
    updateGoogleWorkspaceSync(input: $input) {
      ...FragmentGoogleWorkspaceSync
    }
  }
  ${FRAGMENT_GOOGLE_WORKSPACE_SYNC}
`;

export const MUTATION_DELETE_GOOGLE_WORKSPACE_SYNC = gql`
  mutation deleteGoogleWorkspaceSync($input: DeleteGoogleWorkspaceSyncInput!) {
    deleteGoogleWorkspaceSync(input: $input) {
      ...FragmentGoogleWorkspaceSync
    }
  }
  ${FRAGMENT_GOOGLE_WORKSPACE_SYNC}
`;

export const MUTATION_CREATE_SYNGUARD_GENERIC_LABELS = gql`
  mutation createSynguardGenericLabels(
    $input: CreateSynguardGenericLabelsInput!
  ) {
    createSynguardGenericLabels(input: $input) {
      labels {
        ...SynguardGenericLabelFields
      }
      partialSuccess
      failedCount
    }
  }
  ${FRAGMENT_SYNGUARD_GENERIC_LABEL}
`;

export const MUTATION_UPDATE_RECEPTIONIST_TEAMS_EMAIL = gql`
  mutation updateReceptionistTeamsEmail(
    $input: UpdateReceptionistTeamsEmailInput!
  ) {
    updateReceptionistTeamsEmail(input: $input) {
      id
      title
      email
      callMenuEnabled
      updatedByName
      updatedByEmail
      updatedAt
    }
  }
`;

export const MUTATION_SAVE_CHAT_MESSAGE_TEMPLATE = gql`
  mutation saveChatMessageTemplate(
    $template: ChatMessageTemplateEnum!
    $message: ChatMessageTextInput!
  ) {
    saveChatMessageTemplate(template: $template, message: $message) {
      ...FragmentChatMessageTemplate
    }
  }
  ${FRAGMENT_CHAT_MESSAGE_TEMPLATE}
`;

export const MUTATION_RESET_CHAT_MESSAGE_TEMPLATE = gql`
  mutation resetChatMessageTemplate($template: ChatMessageTemplateEnum!) {
    resetChatMessageTemplate(template: $template) {
      ...FragmentChatMessageTemplate
    }
  }
  ${FRAGMENT_CHAT_MESSAGE_TEMPLATE}
`;
